// extracted by mini-css-extract-plugin
module.exports = {"container":"socials_container__IyFU7","socials":"socials_socials__GLrjO","highlight":"socials_highlight__xTaf2"};